import { render, staticRenderFns } from "./setting-label.vue?vue&type=template&id=37c71b40&scoped=true"
import script from "./setting-label.vue?vue&type=script&lang=js"
export * from "./setting-label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c71b40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37c71b40')) {
      api.createRecord('37c71b40', component.options)
    } else {
      api.reload('37c71b40', component.options)
    }
    module.hot.accept("./setting-label.vue?vue&type=template&id=37c71b40&scoped=true", function () {
      api.rerender('37c71b40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/components/setting-page/components/setting-label.vue"
export default component.exports